import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import { TRIVIA_QUESTIONS } from "../../components/Survey/data";
import { normalizeMessageText } from "../../utils/normalizeText";

const initialState = {
  triviaResponses: [],
  currentQuestion: null,
  currentQuizQuestion: null,
  answerType: null,
  triviaCompleted: false,
  currentTrivia: null,
  currentQuizData: null,
  quizResultObjectId: null,
  resultTableColsMap: {
    date: true,
    score: true,
    rating: true,
    duration: true,
    sentiments: true,
  },
  quizExternalUserData: null,
  currentQuizLinkedRewards: [],
  importTemplateAddedTrivvys: [],
  ratingSubmitted: false,
  rewardModalOpenGlob: false,
  rewardModalPreselectedTrivys: [],
  singleLibraryStats: {
    trivvyCount: 0,
    questionsCount: 0,
  },
  currentTrivvyComments: {},
  showCreatePopup: false,
  libraryScheduleTrivvyLoader: {
    display: false,
    loaderApiData: null,
    minimize: false,
  },
  createTrivvyLoader: {
    display: false,
    loaderApiData: null,
    minimize: false,
  },
  createLibraryLoader: {
    display: false,
    loaderApiData: null,
    minimize: false,
  },
  generateSummaryLoader: {
    display: false,
    loaderApiData: null,
    minimize: false,
  },
  popularImages: [],
  popularVideos: [],
  popularGifs: [],
  TriviaBreakingNews: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_TRIVIA_RESPOSNES:
      return updateObject(state, { triviaResponses: action.payload });
    case actionTypes.SET_TRIVIA_BREAKING_NEWS:
      return updateObject(state, { TriviaBreakingNews: action.payload });
    case actionTypes.SET_CURRENT_QUESTION:
      return updateObject(state, { currentQuestion: action.payload });
    case actionTypes.SET_CURRENT_QUIZ_QUESTION:
      return updateObject(state, { currentQuizQuestion: action.payload });
    case actionTypes.SET_TRIVIA_POPULAR_IMAGES:
      return updateObject(state, { popularImages: action.payload });
    case actionTypes.SET_TRIVIA_POPULAR_VIDEOS:
      return updateObject(state, { popularVideos: action.payload });
    case actionTypes.SET_TRIVIA_POPULAR_GIFS:
      return updateObject(state, { popularGifs: action.payload });
    case actionTypes.SET_ANSWER_TYPE:
      return updateObject(state, { answerType: action.payload });
    case actionTypes.COMPLETE_TRIVIA:
      return updateObject(state, { triviaCompleted: true });

    case actionTypes.RESET_TRIVIA:
      return updateObject(state, {
        triviaResponses: [],
        currentQuizQuestion: "WELCOME",
        currentQuizLinkedRewards: [],
        ratingSubmitted: false,
        quizExternalUserData: null,
      });
    case actionTypes.SET_CURRENT_TRIVIA:
      return updateObject(state, { currentTrivia: action.payload });
    case actionTypes.EDIT_CURRENT_TRIVIA_QUESTIONS:
      return updateObject(state, {
        currentTrivia: {
          ...state.currentTrivia,
          questions: [...action.payload],
        },
      });
    case actionTypes.EDIT_CURRENT_TRIVIA_WELCOME_DATA:
      console.log("first_NGGGGG", action.payload);
      let updateObj = {
        ...state.currentTrivia,
        welcomePage: { ...action.payload },
      }
      if(state.currentTrivia && state.currentTrivia.isMessaging == true){
        // Keep the store clean: the editor passes raw Quill HTML on each keystroke,
        // so normalize to plain text with real newlines before it lands in
        // messagingSubject (idempotent; the debounced autosave normalizes again).
        updateObj.messagingSubject = normalizeMessageText(action.payload.heading)
      }
      return updateObject(state, {
        currentTrivia: {
          // ...state.currentTrivia,
          // welcomePage: { ...action.payload },
          ...updateObj
        },
      });
    case actionTypes.EDIT_CURRENT_TRIVIA_ENDING_DATA:
      return updateObject(state, {
        currentTrivia: {
          ...state.currentTrivia,
          endingPage: { ...action.payload },
        },
      });
    case actionTypes.EDIT_CURRENT_TRIVIA_THEME_DATA:
      return updateObject(state, {
        currentTrivia: {
          ...state.currentTrivia,
          ...(action.payload.type === "WELCOME" && {
            themeSettings: { ...action.payload.themeData },
          }),
          ...(action.payload.type === "RATING" && {
            themeSettingsRatingPage: { ...action.payload.themeData },
          }),
          ...(action.payload.type === "ENDING" && {
            themeSettingsEndingPage: { ...action.payload.themeData },
          }),
        },
      });

    case actionTypes.EDIT_CURRENT_TRIVIA_SHARE_DATA:
      return updateObject(state, {
        currentTrivia: {
          ...state.currentTrivia,
          sharedWithUsers: [...action.payload.sharedWithUsers],
          privacy: action.payload.privacy,
          shareTrivvyViaEmail: action.payload.shareTrivvyViaEmail,
          shareTrivvyViaSMS: action.payload.shareTrivvyViaSMS,
        },
      });

    case actionTypes.SET_CURRENT_QUIZ:
      return updateObject(state, { currentQuizData: action.payload });

    case actionTypes.SET_CURRENT_QUIZ_EXTERNAL_USER_DATA:
      return updateObject(state, {
        quizExternalUserData: {
          ...(state.quizExternalUserData || {}),
          ...action.payload,
        },
      });

    case actionTypes.SET_CURRENT_QUIZ_RESULT_OBJECT_ID:
      return updateObject(state, { quizResultObjectId: action.payload });
    case actionTypes.SET_CURRENT_QUIZ_LINKED_REWARDS:
      return updateObject(state, { currentQuizLinkedRewards: action.payload });
    case actionTypes.SET_TRIVIA_RESULT_TABLE_COLS_MAP:
      return updateObject(state, { resultTableColsMap: action.payload });
    case actionTypes.SET_IMPORT_TEMPLATE_TRIVVYS:
      return updateObject(state, {
        importTemplateAddedTrivvys: action.payload,
      });
    case actionTypes.SET_TRIVVY_RATING_SUBMITTED:
      return updateObject(state, {
        ratingSubmitted: action.payload,
      });
    case actionTypes.OPEN_REAWRD_MODAL_GLOB:
      return updateObject(state, {
        rewardModalOpenGlob: action.payload.open,
        rewardModalPreselectedTrivys: action.payload.trivvys,
      });

    case actionTypes.UPDATE_SINGLE_LIB_STATS_TRIVVY_COUNT:
      const { typeTrivvy, valueTrivvy } = action.payload;
      console.log("vsvsvsvvs", action.payload);
      return updateObject(state, {
        singleLibraryStats: {
          ...state.singleLibraryStats,
          trivvyCount:
            typeTrivvy == "INC"
              ? state.singleLibraryStats.trivvyCount + valueTrivvy
              : typeTrivvy == "DEC"
              ? state.singleLibraryStats.trivvyCount - valueTrivvy
              : valueTrivvy,
        },
      });

    case actionTypes.UPDATE_SINGLE_LIB_STATS_QUESTION_COUNT:
      const { typeQuestion, valueQuestion } = action.payload;
      return updateObject(state, {
        singleLibraryStats: {
          ...state.singleLibraryStats,
          questionsCount:
            typeQuestion == "INC"
              ? state.singleLibraryStats.questionsCount + valueQuestion
              : typeQuestion == "DEC"
              ? state.singleLibraryStats.questionsCount - valueQuestion
              : valueQuestion,
        },
      });

    case actionTypes.SET_CURRENT_TRIVVY_COMMENTS:
      return updateObject(state, {
        currentTrivvyComments: { ...action.payload },
      });

    case actionTypes.SET_CREATE_MODAL_STATE:
      return updateObject(state, {
        showCreatePopup: action.payload,
      });

    case actionTypes.SET_LIBRARY_SCHEDULE_LOADER:
      return updateObject(state, {
        libraryScheduleTrivvyLoader: action.payload,
      });
    case actionTypes.SET_TRIVVY_CREATE_LOADER:
      return updateObject(state, {
        createTrivvyLoader: action.payload,
      });
    case actionTypes.SET_LIBRARY_CREATE_LOADER:
      return updateObject(state, {
        createLibraryLoader: action.payload,
      });
    case actionTypes.SET_SUMMARY_GENERATE_LOADER:
      return updateObject(state, {
        generateSummaryLoader: action.payload,
      });

    default:
      break;
  }
  return state;
}
